<template>
  <div
    id="messages"
    :class="$style.container"
  >
    <slot />
  </div>
</template>
<script>
/**
 * The <AlertContainer> component should be rendered by a parent component that needs to interact
 * with the <slot> content of an <Alert> that the parent renders. An example would be handling an
 * onclick event in the <slot> programmatically.
 *
 * @example
 * <AlertContainer>
 *   <Alert v-if="showWarningAlert">
 *     <span>A warning about something!</span>
 *     <a href="javascript:void(0);" @click="handleClickEvent">Click for more details</a>
 *   </Alert>
 *   <Alert v-if="showSuccessAlert">
 *     <span>{{ this.countOfThings }} things were updated successfully!</span>
 *   </Alert>
 * </AlertContainer>
 *
 * @see
 * https://github.com/TheJumpCloud/jumpcloud-admin-portal/blob/master/client/util/index.js#L66
 */
export default {
  name: 'AlertContainer',
};
</script>
<style module>
@value (alertMessagesZIndex) from '../../css/z-index.css';

.container {
  position: fixed;
  right: 0;
  top: 55px;
  z-index: alertMessagesZIndex;
}
</style>
